import {
  emitProjectAgentRegistryPoke,
  listenProjectAgentRegistryPoke,
} from '@heidi/plugin-rpa';

import { createProjectsBackgroundRegistry } from '../../../data/projects/hooks/projectsBackgroundRegistry';

const registry = createProjectsBackgroundRegistry({
  emitProjectAgentRegistryPoke,
  listenProjectAgentRegistryPoke,
});

export const registerProjectBackground = registry.registerProjectBackground;
export const unregisterProjectBackground = registry.unregisterProjectBackground;
export const subscribeProjectBackground = registry.subscribeProjectBackground;
export const getProjectBackgroundSnapshot = registry.getProjectBackgroundSnapshot;
export const __resetProjectsBackgroundRegistryForTests =
  registry.__resetProjectsBackgroundRegistryForTests;
